import { render, staticRenderFns } from "./google-index.vue?vue&type=template&id=1690dfbe&scoped=true"
import script from "./google-index.vue?vue&type=script&lang=js"
export * from "./google-index.vue?vue&type=script&lang=js"
import style0 from "./google-index.vue?vue&type=style&index=0&id=1690dfbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690dfbe",
  null
  
)

export default component.exports